import React from 'react';
import PropTypes from 'prop-types';

import SignatureTile from './SignatureTile';

export default function SignatureTileView({
  signatures = [],
  isDisplay,
  onClick = null,
  onDelete = null,
  onClear = null,
  showSignatureTime = false,
  collectGeolocation = false,
}) {
  return (
    signatures.map((signature) => (
      <SignatureTile
        key={signature.id}
        signature={signature}
        isDisplay={isDisplay}
        onDelete={isDisplay ? null : onDelete}
        onClear={isDisplay ? null : onClear}
        onClick={isDisplay ? null : onClick}
        showSignatureTime={showSignatureTime}
        collectGeolocation={collectGeolocation}
      />
    ))
  );
}

SignatureTileView.propTypes = {
  signatures: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sig: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    name: PropTypes.string,
    url: PropTypes.string,
    timestamp: PropTypes.number,
    timezone: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
  })),
  isDisplay: PropTypes.bool,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  onClear: PropTypes.func,
  showSignatureTime: PropTypes.bool,
  collectGeolocation: PropTypes.bool,
};

SignatureTileView.defaultProps = {
  signatures: [],
  isDisplay: false,
  onClick: null,
  onDelete: null,
  onClear: null,
  showSignatureTime: false,
  collectGeolocation: false,
};
